import { ApolloClient, ApolloProvider as Provider } from "@apollo/client";
import { FC, PropsWithChildren } from "react";
import link, { placeItLink } from "./link";

import cache from "./cache";
import config from "config";

export const client = new ApolloClient({
  link: link,
  name: config.apollo.name,
  version: config.apollo.version,
  headers: {
    "client-name": config.apollo.name,
    "client-version": config.apollo.version,
  },
  cache: cache,
  connectToDevTools: config.env === "development",
});

export const placeItClient = new ApolloClient({
  link: placeItLink,
  name: config.apollo.name,
  version: config.apollo.version,
  headers: {
    "client-name": config.apollo.name,
    "client-version": config.apollo.version,
  },
  cache: cache,
});

const ApolloProvider: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Provider client={client}>
      {children}
    </Provider>
  );
};

export default ApolloProvider;
